import { ThemeConstellation } from '@zillow/constellation';
import breakpoints from '../../constants/breakpoints';
import { mediaMixin } from '../mixins/mediaMixin';

const logMediaDeprecation = () => {
  // eslint-disable-next-line no-console
  console.warn(
    `The 'media' property from CometTheme will be removed in the next MAJOR release, use 'mediaMixin' from constellation instead.
        http://constellation.pages.zgtools.net/constellation/master/jsdocs/global.html#mediaMixin`,
  );
};

export default {
  ...ThemeConstellation.ns().media,
  xs(styles) {
    logMediaDeprecation();
    return mediaMixin('xs_gte', styles);
  },
  sm(styles) {
    logMediaDeprecation();
    return mediaMixin('sm_gte', styles);
  },
  md(styles) {
    logMediaDeprecation();
    return mediaMixin('md_gte', styles);
  },
  lg(styles) {
    logMediaDeprecation();
    return mediaMixin('lg_gte', styles);
  },
  xl(styles) {
    logMediaDeprecation();
    return mediaMixin('xl_gte', styles);
  },
  xxl(styles) {
    logMediaDeprecation();
    return mediaMixin('xxl_gte', styles);
  },
  BREAKPOINTS: breakpoints,
};
